import { dom } from '@fortawesome/fontawesome-svg-core';
import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import _ from 'lodash';

// import { library } from '@fortawesome/fontawesome-svg-core'
// import * as Icons from '@fortawesome/free-solid-svg-icons';
// const iconList = Object
//     .keys(Icons)
//     .filter(key => key !== "fas" && key !== "prefix")
//     .map(icon => Icons[icon])

// library.add(...iconList)

// import { library, icon } from '@fortawesome/fontawesome-svg-core'
// import { faCamera } from '@fortawesome/free-solid-svg-icons'
// library.add(faCamera)
// const camera = icon({ prefix: 'fas', iconName: 'camera' })

@Component({
  tag: 'nypmegamenu-component',
  styleUrl: 'nypmegamenu-component.css',
  scoped: true
})
export class NypmegamenuComponent {

  /**
 *Required - Unique ID.
 */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
   *Optional - image location - left, right,top or bottom
   */
  @Prop() imagepos: string = "none";

  /**
   *Optional - image col span  if image pos is  left or  right. default is 3
   */
  @Prop() imagecolspan: number = 3;


  /**
   *Optional - To show/hide header - default is true
   */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
*Optional -header text color
*/
  @Prop() headertextcolor: string = "black"
  /**
*Optional -header border bottom css
*/
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
*Optional -embeded video true or false
*/
  @Prop() embededvideo: boolean = false

  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";



  @State() isLoading: boolean = true
  @State() items: []

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;


    let siteUrl: string = "";
    // if ((window as any)._spPageContextInfo != null) {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }
    // else {
    //   let domain = new URL(window.location.href)
    //   siteUrl = domain.origin + this.webpath
    // }



    let domain = new URL(window.location.href)
    siteUrl = domain.origin + this.webpath



    const filter = "ShowInMenu eq 1";

    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,ItemUrl,ShowInMenu,ItemOrder,MenuSection,SectionContent,MenuType,MenuGroupTitle,MenuTypeHeader&$filter=" + filter + "&$orderby=MenuType,ItemOrder&$top=1000", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  checkBody = (bodystring: string) => {
    let returnValue = false;
    let parser = new DOMParser();
    let domNode = parser.parseFromString(bodystring, "text/html");
    const img = domNode.querySelectorAll("img");
    if (img.length > 0 || domNode.body.innerText.length > 1) {
      returnValue = true;
    }
    return returnValue;
    // return domNode.body.innerText;


  }

  fixBody = (bodystring: string) => {

    let parser = new DOMParser();
    let domNode = parser.parseFromString(bodystring, "text/html");
    const img = domNode.querySelectorAll("img");
    const tables = domNode.querySelectorAll("table");
    const videos = domNode.querySelectorAll("video");

    for (let i = 0; i < img.length; i++) {
      img[i].classList.add("sc-nypmegemenu-component", "img-fluid", "rounded");
    }

    if (this.embededvideo) {
      for (let i = 0; i < videos.length; i++) {
        videos[i].setAttribute("controls", "controls")
      }
    }

    for (let i = 0; i < tables.length; i++) {
      tables[i].classList.add("sc-nypmegemenu-component", "table");
    }

    for (let i = 0; i < tables.length; i++) {
      let parent = tables[i].parentNode;
      let divWrapper = document.createElement("div");
      divWrapper.classList.add("sc-nypmegemenu-component", "table-responsive", "tableborder")
      parent.replaceChild(divWrapper, tables[i]);
      divWrapper.appendChild(tables[i]);
    }

    return domNode.body.innerHTML;

  }

  getContents = () => {


    const contentsArray1 = []
    let menutypes = _.uniq(_.map(this.items, 'MenuTypeHeader'))

    menutypes.forEach((element, index) => {


      const left = []
      const center1 = []
      const center2 = []
      const right = []

      let menuItemsLeft = []
      let menuItemsCenter1 = []
      let menuItemsCenter2 = []
      let menuItemsRight = [];
      let menuItemsLeftGroup = []
      let menuItemsCenter1Group = []
      let menuItemsCenter2Group = []
      let menuItemsRightGroup = [];
      let menuGroupTitles = []

      console.log(element + "," + index);



      menuItemsLeft = _.filter(this.items, function (n: any) {

        return n.MenuTypeHeader === element && n.MenuSection === "Left";
      });

      menuGroupTitles = _.uniq(_.map(menuItemsLeft, 'MenuGroupTitle'))
      menuGroupTitles.forEach((menuTitle) => {

        if (menuTitle) {
          left.push(<p style={{ "color": "black", "fontWeight": "600" }} class="dropdown-item"> {menuTitle} </p>)
        }

        menuItemsLeftGroup = _.filter(this.items, function (n: any) {
          return n.MenuTypeHeader === element && n.MenuSection === "Left" && n.MenuGroupTitle === menuTitle;
        });

        menuItemsLeftGroup.forEach((menu) => {
          if (menu.SectionContent && this.checkBody(menu.SectionContent)) {
            left.push(
              <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
            )
          }
          else {
            left.push(
              <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
            )
          }
        })
      })


      menuItemsCenter1 = _.filter(this.items, function (n: any) {
        return n.MenuTypeHeader === element && n.MenuSection === "Center 1";
      });
      menuGroupTitles = _.uniq(_.map(menuItemsCenter1, 'MenuGroupTitle'))
      menuGroupTitles.forEach((menuTitle) => {

        if (menuTitle) {
          center1.push(<p style={{ "color": "black", "fontWeight": "600" }} class="dropdown-item"> {menuTitle} </p>)
        }

        menuItemsCenter1Group = _.filter(this.items, function (n: any) {
          return n.MenuTypeHeader === element && n.MenuSection === "Center 1" && n.MenuGroupTitle === menuTitle;
        });

        menuItemsCenter1Group.forEach((menu) => {
          if (menu.SectionContent && this.checkBody(menu.SectionContent)) {
            center1.push(
              <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
            )
          }
          else {
            center1.push(
              <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
            )
          }
        })
      })


      // menuItemsCenter1 = _.filter(this.items, function (n: any) {
      //   return n.MenuTypeHeader === element && n.MenuSection === "Center 1";
      // });

      // menuItemsCenter1.forEach((menu) => {

      //   if (menu.SectionContent && this.checkBody(menu.SectionContent) && this.checkBody(menu.SectionContent).length > 1) {
      //     center1.push(
      //       <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
      //     )
      //   }
      //   else {
      //     center1.push(
      //       <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
      //     )
      //   }
      // })

      menuItemsCenter2 = _.filter(this.items, function (n: any) {
        return n.MenuTypeHeader === element && n.MenuSection === "Center 2";
      });


      menuGroupTitles = _.uniq(_.map(menuItemsCenter2, 'MenuGroupTitle'))
      menuGroupTitles.forEach((menuTitle) => {

        if (menuTitle) {
          center2.push(<p style={{ "color": "black", "fontWeight": "600" }} class="dropdown-item"> {menuTitle} </p>)
        }

        menuItemsCenter2Group = _.filter(this.items, function (n: any) {
          return n.MenuTypeHeader === element && n.MenuSection === "Center 2" && n.MenuGroupTitle === menuTitle;
        });

        menuItemsCenter2Group.forEach((menu) => {
          if (menu.SectionContent && this.checkBody(menu.SectionContent)) {
            center2.push(
              <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
            )
          }
          else {
            center2.push(
              <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
            )
          }
        })
      })



      // menuItemsCenter2.forEach((menu) => {
      //   if (menu.SectionContent && this.checkBody(menu.SectionContent) && this.checkBody(menu.SectionContent).length > 1) {
      //     center2.push(
      //       <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
      //     )
      //   }
      //   else {
      //     center2.push(
      //       <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
      //     )
      //   }
      // })


      menuItemsRight = _.filter(this.items, function (n: any) {
        return n.MenuTypeHeader === element && n.MenuSection === "Right";
      });


      menuGroupTitles = _.uniq(_.map(menuItemsRight, 'MenuGroupTitle'))
      menuGroupTitles.forEach((menuTitle) => {

        if (menuTitle) {
          right.push(<p style={{ "color": "black", "fontWeight": "600" }} class="dropdown-item"> {menuTitle} </p>)
        }

        menuItemsRightGroup = _.filter(this.items, function (n: any) {
          return n.MenuTypeHeader === element && n.MenuSection === "Right" && n.MenuGroupTitle === menuTitle;
        });

        menuItemsRightGroup.forEach((menu) => {
          if (menu.SectionContent && this.checkBody(menu.SectionContent)) {
            right.push(
              <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
            )
          }
          else {
            right.push(
              <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
            )
          }
        })
      })


      // menuItemsRight.forEach((menu) => {
      //   if (menu.SectionContent && this.checkBody(menu.SectionContent) && this.checkBody(menu.SectionContent).length > 1) {
      //     right.push(
      //       <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
      //     )
      //   }
      //   else {
      //     right.push(
      //       <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
      //     )
      //   }
      // })


      // this.getMenu(element,menuArray);
      let id = "navbarDropdown-" + index

      contentsArray1.push(<li class="nav-item dropdown dropdown-mega position-static">
        <a class="nav-link dropdown-toggle" href="#" id={id} role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          {element}
        </a>
        <ul class="dropdown-menu" aria-labelledby="navbarDropdown" style={{ "width": "100%", "border": "0", "left": "0px" }}>

          <div class="mega-content px-4" >
            <div class="container-fluid">

              <div class="row">
                <div class="col-12 col-sm-4 col-md-3 py-4">
                  {left} </div>
                <div class="col-12 col-sm-4 col-md-3 py-4">
                  {center1} </div>
                <div class="col-12 col-sm-4 col-md-3 py-4">
                  {center2} </div>
                <div class="col-12 col-sm-4 col-md-3 py-4">{right}</div>
              </div>
            </div>
          </div>
        </ul>
      </li>




      )

    })


    const contentsArray = (
      <nav class="navbar navbar-expand-lg navbar-light bg-light" style={{ "fontSize": "16px" }}>
        <div class="container-fluid">
          <a class="navbar-brand" href="/">   <i style={{ "fontSize": "20px" }} class="fa fa-home"></i></a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              {contentsArray1}
            </ul>
            <div class="d-flex">
              <input class="form-control me-2" type="search" placeholder="Search" id="infonet-customsearch" aria-label="Search" />
              <button class="btn btn-outline-secondary" type="button" id="infonet-customsearch-btn" onClick={this.searchOnClick}>Search</button>
            </div>
          </div>
        </div>
      </nav>
    )
    return contentsArray
  }


searchOnClick =() => {

    var term = (document.getElementById('infonet-customsearch') as HTMLInputElement).value
      // var term =  document.getElementById('infonet-customsearch').value
    console.log("Search term:"+ term)
    
    if (term)
    {
    
    window.location.href = "https://infonet.nyp.org/SearchCenter/Pages/results.aspx#k=" + term;
    
    }
 
  }


  addListener = () => {
    const textInput = document.getElementById('infonet-customsearch');
    textInput.addEventListener('keydown', (event) => {
  
        console.log("event addeded");
        if (event.key === 'Enter') {
            var term =  (document.getElementById('infonet-customsearch') as HTMLInputElement).value
            console.log("Search term:" + term)
            if (term) {
               window.location.href = "https://infonet.nyp.org/SearchCenter/Pages/results.aspx#k=" + term;
            }
        }
    })
  }

  render() {


    return (
      this.isLoading ?
        <loader-component /> :
        <div >
          {this.getContents()}
          {/* {this.addListener()} */}
        </div>

    )

  }
}
